<template>
  <div id="Other">
    <div class="section" :class="$mq">
      <div class="title">{{ $t("step2.other.title") }}</div>
      <div class="container inline bottom">
        <EnergyButton 
          @click="electricCar = !electricCar"
          :active="electricCar"
          :title="$t('step2.other.electricCar')"
          type="electric-car"
          :radio="false"
          :stroke="true"
        />
        <EnergyButton 
          v-if="showBattery"
          @click="battery = !battery"
          :active="battery"
          :title="$t('step2.other.battery')"
          type="home-battery"
          :radio="false"
          :stroke="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import EnergyButton from '@/components/Energy/EnergyButton.vue';

export default {
  props: {
    showBattery: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  computed: {
    battery: {
      get() {
        return this.$store.state.consumption.battery;
      },
      set(value) {
        this.$store.commit("consumption/setBattery", value);
      }
    },
    electricCar: {
      get() {
        return this.$store.state.consumption.electricCar;
      },
      set(value) {
        this.$store.commit("consumption/setElectricCar", value);
      }
    }
  },
  components: {
    EnergyButton
  }
};
</script>



// WEBPACK FOOTER //
// src/views/consumption/KnowConsumption/Other.vue